<template>
  <svg width="36" height="36" viewBox="8 8 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable max-len -->
    <path d="M24 9.625L11.5 12.75V19.375C11.5 19.97 11.5338 20.6675 11.6063 21.2588C11.7788 22.665 12.1813 25.3012 12.9762 27.4962C14.9362 32.9087 18.5913 36.6188 23.5463 38.2275L24 38.375L24.4537 38.2275C29.4087 36.6188 33.0638 32.9087 35.0238 27.4962C35.8063 25.3337 36.21 22.7437 36.3863 21.3225C36.4613 20.71 36.5 19.9925 36.5 19.375V12.75L24 9.625ZM34 19.4262C34 19.95 33.9663 20.5162 33.9038 21.0162C33.7475 22.28 33.38 24.6925 32.6737 26.6437C31.03 31.1862 28.035 34.325 24.0013 35.7412C19.9663 34.3237 16.9725 31.185 15.3288 26.645C15.0425 25.855 14.8138 24.9925 14.63 24.1575L24 26.5V24L14.165 21.5412C14.1362 21.3287 14.11 21.13 14.0888 20.9562C14.0313 20.4912 14 19.9487 14 19.4262V19L24 21.5V19L14 16.5V14.6875L24 12.2025L34 14.6875V19.4262Z" fill="#ED1F24"/>
    <!-- eslint-enable max-len -->
  </svg>
</template>

<script>
export default {
  name: 'DvlsIcon',
};
</script>
